export const DEFAULT_DASHBOARD_WIDGET_SIZE = { rowSpan: 3, colSpan: 4 };
